import ModalFormDetail from "./FormDetail";
import {
	CLC_CALENDAR_DETAIL,
	DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export const SchemaDetail = {
	components: { ModalFormDetail },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: CLC_CALENDAR_DETAIL,
			tableId: "CLC_CALENDAR_DETAIL-table",
			rowData: {},
			formId: "CLC_CALENDAR_DETAIL-form",
			tableColumns: [
				{
					title: "Calendar Name",
					type: "custom-html",
					key: "academic_calendar_id",
                    isVisible: true,
                    modifier: (value) => {
                        return value?.academic_calendar_name
                    }
				},
				{
					title: "Date",
					type: "text",
					key: "date",
				},
				{
					title: "Description",
					type: "text",
					key: "description",
				},
                {
					title: "CLC Date",
					type: "text",
					key: "clc_date",
				},
                {
					title: "Is Holiday",
					type: "custom-html",
					key: "is_holiday",
					isVisible: true,
					modifier: (value) => {
						let ClassName = "danger";

						if (value === 1) ClassName = `success`;
						else if (value === 0) ClassName = `warning`;

						return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
							value ? "Holiday" : "Weekday"
						}</span>`;
					},
				},
				{
					title: this.$t("is_active"),
					type: "custom-html",
					key: "is_active",
					isVisible: true,
					modifier: (value) => {
						let ClassName = "danger";

						if (value === 1) ClassName = `success`;
						else if (value === 0) ClassName = `warning`;

						return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
							value ? "Active" : "Inactive"
						}</span>`;
					},
				},
			],
			ENDPOINT: CLC_CALENDAR_DETAIL + "?academic_calendar_id=" + this.clcCalendarRowData.id,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ClcCalendar",
				url: CLC_CALENDAR_DETAIL + "?academic_calendar_id=" + this.clcCalendarRowData.id,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "CLC_CALENDAR_DETAIL-form",
						modalId: "CLC_CALENDAR_DETAIL-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
					{
						title: this.$t("is_active"),
						type: "checkbox",
						key: "is_active",
						option: [
							{ id: true, value: "Active" },
							{ id: false, value: "Inactive" },
						],
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = CLC_CALENDAR_DETAIL + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
